import React from "react";
import {
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

const StandardCakeOutsideIcing = ({ formData, setFormData, icingOptions }) => {
  return (
    <>
      <Typography sx={{ mt: 2, mb: 1 }}>Outside Icing</Typography>
      <FormControl fullWidth>
        <InputLabel>Select Outside Icing</InputLabel>
        <Select
          value={formData.outsideIcing}
          onChange={(e) =>
            setFormData({ ...formData, outsideIcing: e.target.value })
          }>
          {icingOptions.map((icing) => (
            <MenuItem key={icing._id} value={icing._id}>
              {icing.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StandardCakeOutsideIcing;
